import { CommerceService } from "@/services/commerce"

/**
 * If triggered more than once (custom type exists, error will be returned)
 *
 * Kept here to track progress and for future migrations.
 * Purpose to add custom fields for customer in commercetools
 */
export const mutationAddCustomerCustomType = {
  async addCustomerCustomType(parent, args, context, info) {
    const commerceApi = CommerceService.api()

    const typeDraft = {
      key: "customerCustomTypeKey",
      name: { "de-DE": "customerCustomTypeName", "en-US": "customerCustomTypeName" },
      description: {
        "de-DE": "Benutzerdefinierte Felder für einen Kunden",
        "en-US": "Custom fields for a customer",
      },
      resourceTypeIds: ["customer"],
      fieldDefinitions: [
        {
          type: { name: "String" },
          name: "orderConfirmationEmail",
          label: {
            "de-DE": "E-Mail für Auftragsbestätigung",
            "en-US": "E-Mail für Auftragsbestätigung",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "offerAvailable",
          label: {
            "de-DE": "Angebot vorhanden",
            "en-US": "Angebot vorhanden",
          },
          required: false,
        },
        {
          type: { name: "Date" },
          name: "creationDate",
          label: {
            "de-DE": "Anlagedatum",
            "en-US": "Anlagedatum",
          },
          required: false,
        },
        {
          type: { name: "Date" },
          name: "lawyerHiredDate",
          label: {
            "de-DE": "OP-Liste: Anwalt beauftragt am",
            "en-US": "OP-Liste: Anwalt beauftragt am",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "lawyerHired",
          label: {
            "de-DE": "OP-Liste: Anwalt beauftragt",
            "en-US": "OP-Liste: Anwalt beauftragt",
          },
          required: false,
        },
        {
          type: { name: "Number" },
          name: "numberOfInvoiceCopies",
          label: {
            "de-DE": "Anzahl Rechnungskopien",
            "en-US": "Anzahl Rechnungskopien",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "orderConfirmation",
          label: {
            "de-DE": "Auftragsbestätigung",
            "en-US": "Auftragsbestätigung",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "notify",
          label: {
            "de-DE": "Avisieren",
            "en-US": "Avisieren",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "processingFee",
          label: {
            "de-DE": "Bearbeitungszuschlag",
            "en-US": "Bearbeitungszuschlag",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "recordOrderNumberOnDeliveryNote",
          label: {
            "de-DE": "Bestell-Nr. muss beim Lieferschein erfasst werden",
            "en-US": "Bestell-Nr. muss beim Lieferschein erfasst werden",
          },
          required: false,
        },
        {
          type: { name: "Number" },
          name: "exchangeIdForInvoiceTransmission",
          label: {
            "de-DE": "Austausch ID für die eingestellte Art des Rechnungsversands",
            "en-US": "Austausch ID für die eingestellte Art des Rechnungsversands",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "typeOfInvoiceTransmission",
          label: {
            "de-DE": "Art des Rechnungsversands",
            "en-US": "Art des Rechnungsversands",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "expertAdvisor",
          label: {
            "de-DE": "Fachberater",
            "en-US": "Fachberater",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "companyNumber",
          label: {
            "de-DE": "Firmennummer",
            "en-US": "Firmennummer",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "freightSurcharge",
          label: {
            "de-DE": "Frachtkostenzuschlag",
            "en-US": "Frachtkostenzuschlag",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "globalLocationNumber",
          label: {
            "de-DE": "Global Location Number - EDIFACT",
            "en-US": "Global Location Number - EDIFACT",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "hermesLimitMaximum",
          label: {
            "de-DE": "(Hermes) Limit Maximum",
            "en-US": "(Hermes) Limit Maximum",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "hermesCreditInsurance",
          label: {
            "de-DE": "(Hermes) Kreditversicherung",
            "en-US": "(Hermes) Kreditversicherung",
          },
          required: false,
        },
        {
          type: { name: "Number" },
          name: "hermesCreditLimit",
          label: {
            "de-DE": "(Hermes) Kreditlimit in Tsd. EUR",
            "en-US": "(Hermes) Kreditlimit in Tsd. EUR",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "insideServiceEmployee",
          label: {
            "de-DE": "Innendienstmitarbeiter",
            "en-US": "Innendienstmitarbeiter",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "intrastatDeclaration",
          label: {
            "de-DE": "Intrastatmeldung",
            "en-US": "Intrastatmeldung",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "customerBranch",
          label: {
            "de-DE": "Kunden-Filiale",
            "en-US": "Kunden-Filiale",
          },
          required: false,
        },
        {
          type: { name: "Date" },
          name: "bankcruptcyDate",
          label: {
            "de-DE": "OP-Liste: Konkurs Datum",
            "en-US": "OP-Liste: Konkurs Datum",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "bankcruptcy",
          label: {
            "de-DE": "Op-Liste: Konkurs",
            "en-US": "Op-Liste: Konkurs",
          },
          required: false,
        },
        {
          type: { name: "Number" },
          name: "einzaCreditLimit",
          label: {
            "de-DE": "(einzA) Kreditlimit in Tsd. EUR",
            "en-US": "(einzA) Kreditlimit in Tsd. EUR",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "storchCustomerNumber",
          label: {
            "de-DE": "Kundennummer bei Storch",
            "en-US": "Kundennummer bei Storch",
          },
          required: false,
        },
        {
          type: { name: "Date" },
          name: "lastOrderDate",
          label: {
            "de-DE": "Datum des letzten Auftrags",
            "en-US": "Datum des letzten Auftrags",
          },
          required: false,
        },
        {
          type: { name: "Date" },
          name: "lastOrderLastModifiedDate",
          label: {
            "de-DE": "Datum der letzten Auftragsänderung",
            "en-US": "Datum der letzten Auftragsänderung",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "deliveryBranch",
          label: {
            "de-DE": "Liefer-Filiale",
            "en-US": "Liefer-Filiale",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "truckTourNumber",
          label: {
            "de-DE": "LKW-Tour-Nr.",
            "en-US": "LKW-Tour-Nr.",
          },
          required: false,
        },
        {
          type: { name: "Date" },
          name: "lastInvoiceDate",
          label: {
            "de-DE": "Datum der letzten Rechnung",
            "en-US": "Datum der letzten Rechnung",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "dunningKey",
          label: {
            "de-DE": "Mahnschlüssel",
            "en-US": "Mahnschlüssel",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "dunningBlock",
          label: {
            "de-DE": "Mahnsperre",
            "en-US": "Mahnsperre",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "customerNumberAccounting",
          label: {
            "de-DE": "Kundenummer für Buchhaltung",
            "en-US": "Kundenummer für Buchhaltung",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "matchCode",
          label: {
            "de-DE": "Matchcode / Suchfeld",
            "en-US": "Matchcode / Suchfeld",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "underInvoicing",
          label: {
            "de-DE": "Minderfakturierung",
            "en-US": "Minderfakturierung",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "vatKey",
          label: {
            "de-DE": "Mehrwertsteuerschlüssel",
            "en-US": "Mehrwertsteuerschlüssel",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "customerClassification",
          label: {
            "de-DE": "Kundenklassifizierung",
            "en-US": "Kundenklassifizierung",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "personnelNumber",
          label: {
            "de-DE": "Personalnummer",
            "en-US": "Personalnummer",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "preferentialAgreement",
          label: {
            "de-DE": "Präferenzabkommen",
            "en-US": "Präferenzabkommen",
          },
          required: false,
        },
        {
          type: { name: "Number" },
          name: "datanormExportPrice",
          label: {
            "de-DE": "Datanorm Export Preis",
            "en-US": "Datanorm Export Preis",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "datanormExportAhgs",
          label: {
            "de-DE": "Datanorm Export AHGs",
            "en-US": "Datanorm Export AHGs",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "datanormExportEmail",
          label: {
            "de-DE": "Datanorm Export E-Mail",
            "en-US": "Datanorm Export E-Mail",
          },
          required: false,
        },
        {
          type: { name: "Number" },
          name: "datanormExportFormat",
          label: {
            "de-DE": "Datanorm Export Format",
            "en-US": "Datanorm Export Format",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "datanormExport",
          label: {
            "de-DE": "Datanorm Export",
            "en-US": "Datanorm Export",
          },
          required: false,
        },
        {
          type: { name: "Date" },
          name: "installmentPaymentDate",
          label: {
            "de-DE": "OP-Liste: Ratenzahlung Datum",
            "en-US": "OP-Liste: Ratenzahlung Datum",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "installmentPayment",
          label: {
            "de-DE": "OP-Liste: Ratenzahlung",
            "en-US": "OP-Liste: Ratenzahlung",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "controlInvoices",
          label: {
            "de-DE": "Rechnungen aussteuern",
            "en-US": "Rechnungen aussteuern",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "invoiceEmail",
          label: {
            "de-DE": "Rechnungs-E-Mail",
            "en-US": "Rechnungs-E-Mail",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "collectiveInvoiceKey",
          label: {
            "de-DE": "Sammelrechnung",
            "en-US": "Sammelrechnung",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "shopEmail",
          label: {
            "de-DE": "Shop E-Mail",
            "en-US": "Shop E-Mail",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "customerStatus",
          label: {
            "de-DE": "Status",
            "en-US": "Status",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "customerStreetTwo",
          label: {
            "de-DE": "Straße 2",
            "en-US": "Straße 2",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "customerStreetThree",
          label: {
            "de-DE": "Straße 3",
            "en-US": "Straße 3",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "tourNumber",
          label: {
            "de-DE": "Tournummer",
            "en-US": "Tournummer",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "associationNumber",
          label: {
            "de-DE": "Verbandnummer",
            "en-US": "Verbandnummer",
          },
          required: false,
        },
        {
          type: { name: "Date" },
          name: "legalSettlementDate",
          label: {
            "de-DE": "OP-Liste: Vergleich erreicht am",
            "en-US": "OP-Liste: Vergleich erreicht am",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "legalSettlement",
          label: {
            "de-DE": "OP-Liste: Vergleich erreicht",
            "en-US": "OP-Liste: Vergleich erreicht",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "transitDeclaration",
          label: {
            "de-DE": "Versandmeldung",
            "en-US": "Versandmeldung",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "admSalesRepresentive",
          label: {
            "de-DE": "Außendienstmitarbeiter",
            "en-US": "Außendienstmitarbeiter",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "printSellingPrice",
          label: {
            "de-DE": "VK Andruck",
            "en-US": "VK Andruck",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "vocIncentiveTax",
          label: {
            "de-DE": "VOC Lenkungsabgabe",
            "en-US": "VOC Lenkungsabgabe",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "webShopCustomer",
          label: {
            "de-DE": "Web-Shop-Kunde",
            "en-US": "Web-Shop-Kunde",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "paymentMethod",
          label: {
            "de-DE": "Zahlart",
            "en-US": "Zahlart",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "euro",
          label: {
            "de-DE": "Euro",
            "en-US": "Euro",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "businessVolume",
          label: {
            "de-DE": "Geschäftsvolumen",
            "en-US": "Geschäftsvolumen",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "numberOfEmployees",
          label: {
            "de-DE": "Anzahl Mitarbeiter",
            "en-US": "Anzahl Mitarbeiter",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "activeCompetitors",
          label: {
            "de-DE": "Aktive Wettbewerber",
            "en-US": "Aktive Wettbewerber",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "customers",
          label: {
            "de-DE": "Kunden",
            "en-US": "Kunden",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "memberships",
          label: {
            "de-DE": "Mitgliedschaften",
            "en-US": "Mitgliedschaften",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "modificationSource",
          label: {
            "de-DE": "Modification source",
            "en-US": "Modification source",
          },
          required: false,
        },
        {
          type: { name: "DateTime" },
          name: "modifiedAt",
          label: {
            "de-DE": "Letzte Änderung am",
            "en-US": "Letzte Änderung am",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "modifiedBy",
          label: {
            "de-DE": "Geändert von",
            "en-US": "Geändert von",
          },
          required: false,
        },
        {
          type: {
            name: "Reference",
            referenceTypeId: "key-value-document",
          },
          name: "discountKey",
          label: {
            "de-DE": "Skonto",
            "en-US": "Skonto",
          },
          required: false,
        },
        {
          type: {
            name: "Reference",
            referenceTypeId: "key-value-document",
          },
          name: "industryKey",
          label: {
            "de-DE": "Branche",
            "en-US": "Branche",
          },
          required: false,
        },
        {
          type: { name: "Number" },
          name: "revenueYTD",
          label: {
            "de-DE": "Umsatz YTD",
            "en-US": "Umsatz YTD",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "cost_unit_mandatory",
          label: {
            "de-DE": "Kostenträger Pflichtfeld",
            "en-US": "Kostenträger Pflichtfeld",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "foundingDate",
          label: {
            "de-DE": "Gründungsdatum",
            "en-US": "Founding date",
          },
          required: false,
        },
      ],
    }

    try {
      await commerceApi.types().post({ body: typeDraft }).execute()

      return true
    } catch (error) {
      throw new Error(error)
    }
  },
}
